import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as EditIcon } from 'common/assets/images/edit-Icon.svg';
import {
	dateInCorrectFormatWithFullYear,
	toSentenceCase,
} from 'common/utils/utilFunctions';

import styles from './Roles/RolesTable.module.scss';

const { editIconColor, deleteIconFillColor } = styles;
export const commonDetailsTemplate = (onActionClick: any) => [
	{
		id: 'usersCount',
		label: 'Users',
		disablePadding: false,
		isSortable: true,
	},
	{
		id: 'createdDate',
		label: toSentenceCase('Created Date'),
		disablePadding: false,
		isSortable: true,
		render: (params: any) => (
			<div>
				{params?.createdDate &&
					dateInCorrectFormatWithFullYear(params?.createdDate)}
			</div>
		),
	},
	{
		id: 'modifiedDate',
		label: toSentenceCase('Last Updated Date'),
		disablePadding: false,
		isSortable: true,
		render: (params: any) => (
			<div>
				{params?.modifiedDate &&
					dateInCorrectFormatWithFullYear(params?.modifiedDate)}
			</div>
		),
	},
	{
		id: 'actions',
		label: 'Actions',
		disablePadding: false,
		isSortable: false,
		render: (params: any) => (
			<div className={styles['icon-actions-container']}>
				<EditIcon
					data-testid="edit-icon"
					fill={editIconColor}
					className={styles['icon-actions']}
					onClick={() => {
						onActionClick(params, 'Edit');
					}}
				/>
				<DeleteIcon
					data-testid="delete-icon"
					className={styles['icon-actions']}
					onClick={() => {
						onActionClick(params, 'Delete');
					}}
					fill={deleteIconFillColor}
				/>
			</div>
		),
	},
];

export const generateCommonColumns = (onActionClick: any) =>
	commonDetailsTemplate(onActionClick).map((column) => ({
		...column,
	}));
